import { e } from "../../../chunk-GSYRQO2U-911f8fc9.js";
import { createMultiStyleConfigHelpers as l, cssVar as t } from "@chakra-ui/react";
const { definePartsStyle: o, defineMultiStyleConfig: i } = l(
  e.keys
), r = t("textarea-bg"), s = o({
  iconButton: {
    position: "absolute",
    right: "spacing-75",
    top: "0"
  },
  textarea: {
    width: "full",
    height: "80px",
    borderRadius: "8px",
    borderWidth: "1px",
    borderColor: "primary.100",
    fontSize: "lg",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    color: "primary.500",
    padding: 4,
    [r.variable]: "colors.white",
    background: r.reference,
    '&[data-smart-loading="true"]': {
      pointerEvents: "none"
    },
    _disabled: {
      opacity: 0.5
    },
    _invalid: {
      borderColor: "error.300",
      color: "error.500",
      _hover: {
        borderColor: "error.300",
        color: "error.700",
        outlineColor: "primary.50",
        outlineStyle: "solid",
        outlineWidth: "4px"
      },
      _focusVisible: {
        color: "error.700",
        borderColor: "error.500",
        outlineColor: "error.50",
        outlineStyle: "solid",
        outlineWidth: "4px"
      }
    }
  }
}), n = {
  primary: o({
    textarea: {
      _hover: {
        borderColor: "primary.300",
        outlineColor: "primary.50",
        outlineStyle: "solid",
        outlineWidth: "2px"
      },
      _focusVisible: {
        borderColor: "secondary.500",
        outlineColor: "secondary.50",
        outlineStyle: "solid",
        outlineWidth: "2px"
      },
      _placeholder: {
        color: "primary.300"
      }
    }
  }),
  success: o({
    textarea: {
      borderColor: "success.300",
      color: "success.500",
      _hover: {
        borderColor: "success.300",
        color: "success.700",
        outlineColor: "primary.50",
        outlineStyle: "solid",
        outlineWidth: "3px"
      },
      _focusVisible: {
        color: "success.700",
        borderColor: "success.500",
        outlineColor: "success.50",
        outlineStyle: "solid",
        outlineWidth: "2px"
      }
    }
  }),
  error: o({
    textarea: {
      borderColor: "error.300",
      color: "error.500",
      _hover: {
        borderColor: "error.300",
        color: "error.700",
        outlineColor: "primary.50",
        outlineStyle: "solid",
        outlineWidth: "3px"
      },
      _focusVisible: {
        color: "error.700",
        borderColor: "error.500",
        outlineColor: "error.50",
        outlineStyle: "solid",
        outlineWidth: "2px"
      }
    }
  })
}, c = i({
  baseStyle: s,
  variants: n,
  defaultProps: {
    variant: "primary"
  }
});
export {
  c as Textarea
};
//# sourceMappingURL=Textarea.es.js.map
